import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Challenges from "./pages/Challenges";
import Admin from "./pages/Admin";
import AuthSuccess from "./pages/AuthSuccess";
import GameDetail from "./pages/GameDetail";
import Profile from "./pages/Profile";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Partner from "./pages/Partner";
import Faq from "./pages/Faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/games/:slug" element={<GameDetail />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/auth/success" element={<AuthSuccess />} />
          <Route path="/p/:name" element={<Profile />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center text-white px-6">
      <div className="text-center">
        <div className="text-[13px] text-white/40">404</div>
        <h1 className="mt-2 text-3xl font-bold">This table doesn&apos;t exist.</h1>
        <p className="mt-2 text-white/60 text-[14px]">The page you&apos;re looking for went bust.</p>
        <Link to="/" className="mt-6 inline-block text-white/70 hover:text-white">Back home</Link>
      </div>
    </div>
  );
}

export default App;
